import React, { useState } from 'react';
import toast from 'react-hot-toast';

const SUPABASE_URL = 'https://qbkcnqenjiheradrxugy.supabase.co';
const SUPABASE_KEY = 'sb_publishable_epceF2XZNSNnogfsLn3idA_erFApSWI';

export default function PhotoUpload({ currentUrl, onUpload, equipementId }) {
  const [uploading, setUploading] = useState(false);
  const [preview, setPreview] = useState(currentUrl || null);

  const handleFile = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    if (!file.type.startsWith('image/')) return toast.error('Fichier image requis');
    if (file.size > 5 * 1024 * 1024) return toast.error('Image trop lourde (max 5 MB)');

    setUploading(true);
    try {
      const ext = file.name.split('.').pop();
      const filename = `equipements/${equipementId || Date.now()}.${ext}`;

      const res = await fetch(`${SUPABASE_URL}/storage/v1/object/photos/${filename}`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${SUPABASE_KEY}`,
          'Content-Type': file.type,
          'x-upsert': 'true',
        },
        body: file,
      });

      if (!res.ok) throw new Error('Upload échoué');

      const url = `${SUPABASE_URL}/storage/v1/object/public/photos/${filename}`;
      setPreview(url);
      onUpload(url);
      toast.success('Photo uploadée');
    } catch (e) {
      toast.error('Erreur upload: ' + e.message);
    } finally { setUploading(false); }
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
      {preview && (
        <div style={{ position: 'relative', width: '100%', maxWidth: 200 }}>
          <img src={preview} alt="Équipement"
            style={{ width: '100%', borderRadius: 8, border: '1px solid var(--border)', objectFit: 'cover', maxHeight: 150 }} />
          <button onClick={() => { setPreview(null); onUpload(''); }}
            style={{ position: 'absolute', top: 4, right: 4, background: '#ef4444', color: '#fff', border: 'none', borderRadius: '50%', width: 22, height: 22, cursor: 'pointer', fontSize: 12 }}>
            ✕
          </button>
        </div>
      )}
      <label style={{
        display: 'inline-flex', alignItems: 'center', gap: 8,
        padding: '8px 14px', borderRadius: 6,
        border: '1px dashed var(--border)', cursor: 'pointer',
        fontSize: 13, color: 'var(--text-secondary)',
        background: 'var(--bg)', transition: 'all 0.15s',
        width: 'fit-content',
      }}>
        <input type="file" accept="image/*" onChange={handleFile} style={{ display: 'none' }} />
        {uploading ? '⏳ Upload...' : preview ? '🔄 Changer la photo' : '📷 Ajouter une photo'}
      </label>
    </div>
  );
}
